import { render, staticRenderFns } from "./ConfigurablePopupButton.vue?vue&type=template&id=1bbd1796&scoped=true"
import script from "./ConfigurablePopupButton.vue?vue&type=script&lang=js"
export * from "./ConfigurablePopupButton.vue?vue&type=script&lang=js"
import style0 from "./ConfigurablePopupButton.vue?vue&type=style&index=0&id=1bbd1796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd1796",
  null
  
)

export default component.exports